module.exports = __webpack_public_path__ + "static/media/manager.f82dafa6.svg";